<template>
  <div v-if="isLoading" class="loading-wrapper align">

    <div class="overlay"></div>

    <div class="lds-facebook align">
      <div></div><div></div><div></div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'BoardLoading',
  props: {
    loadingState: {
      type: Boolean,
      isRequired: false,
    },
  },
  computed: {
    isLoading() {
      return this.loadingState;
    },
  },
};
</script>

<style lang="scss" scoped>
.align {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  align-items: center;
}

.loading-wrapper {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 1000;

  .overlay {
    position: absolute;

    width: 100vw;
    height: 100vh;

    background-color: rgba(1, 1, 1, 0.2);

    z-index: 1000;
  }

  .lds-facebook {
    z-index: 1001;

    display: inline-block;
    position: relative;
    width: 64px;
    height: 64px;

    transform: translate(-50%, -50%);
  }

  .lds-facebook div {
    display: inline-block;
    position: absolute;
    left: 6px;
    width: 13px;
    background-color: #fff;
    animation: lds-facebook 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
  }

  .lds-facebook div:nth-child(1) {
    left: 6px;
    animation-delay: -0.24s;
  }

  .lds-facebook div:nth-child(2) {
    left: 26px;
    animation-delay: -0.12s;
  }

  .lds-facebook div:nth-child(3) {
    left: 45px;
    animation-delay: 0;
  }

  @keyframes lds-facebook {
    0% {
      top: 6px;
      height: 51px;
    }
    50%, 100% {
      top: 19px;
      height: 26px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/spa/components/table/components/BoardLoading.vue